/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
 */
export interface ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    systemDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    manufacturerName?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    _configuration?: object | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    metadata?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    status?: number | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    costPerKm?: object;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    tankSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    customLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    vehicleTrainMaxWeight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    vehicleTractorMaxWeight?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    cng?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    disabledAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    forwardedToDff?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    lastSyncWithDff?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    dffSyncTraceback?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    monitoringDevice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    client: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    monitoredObjectType: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    driverApplication?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    externalSystem?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject
     */
    countryOfRegistration?: number | null;
}

export function ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectFromJSON(json: any): ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject {
    return ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'externalId': !exists(json, 'external_id') ? undefined : json['external_id'],
        'registrationNumber': json['registration_number'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'systemDescription': !exists(json, 'system_description') ? undefined : json['system_description'],
        'manufacturerName': !exists(json, 'manufacturer_name') ? undefined : json['manufacturer_name'],
        '_configuration': !exists(json, 'configuration') ? undefined : json['configuration'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'costPerKm': !exists(json, 'cost_per_km') ? undefined : json['cost_per_km'],
        'tankSize': !exists(json, 'tank_size') ? undefined : json['tank_size'],
        'customLabel': !exists(json, 'custom_label') ? undefined : json['custom_label'],
        'vehicleTrainMaxWeight': !exists(json, 'vehicle_train_max_weight') ? undefined : json['vehicle_train_max_weight'],
        'vehicleTractorMaxWeight': !exists(json, 'vehicle_tractor_max_weight') ? undefined : json['vehicle_tractor_max_weight'],
        'cng': !exists(json, 'cng') ? undefined : json['cng'],
        'disabledAt': !exists(json, 'disabled_at') ? undefined : (json['disabled_at'] === null ? null : new Date(json['disabled_at'])),
        'forwardedToDff': !exists(json, 'forwarded_to_dff') ? undefined : json['forwarded_to_dff'],
        'lastSyncWithDff': !exists(json, 'last_sync_with_dff') ? undefined : (json['last_sync_with_dff'] === null ? null : new Date(json['last_sync_with_dff'])),
        'dffSyncTraceback': !exists(json, 'dff_sync_traceback') ? undefined : json['dff_sync_traceback'],
        'monitoringDevice': !exists(json, 'monitoring_device') ? undefined : json['monitoring_device'],
        'client': json['client'],
        'monitoredObjectType': json['monitored_object_type'],
        'driverApplication': !exists(json, 'driver_application') ? undefined : json['driver_application'],
        'externalSystem': !exists(json, 'external_system') ? undefined : json['external_system'],
        'countryOfRegistration': !exists(json, 'country_of_registration') ? undefined : json['country_of_registration'],
    };
}

export function ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectToJSON(value?: ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'external_id': value.externalId,
        'registration_number': value.registrationNumber,
        'description': value.description,
        'system_description': value.systemDescription,
        'manufacturer_name': value.manufacturerName,
        'configuration': value._configuration,
        'metadata': value.metadata,
        'note': value.note,
        'status': value.status,
        'cost_per_km': value.costPerKm,
        'tank_size': value.tankSize,
        'custom_label': value.customLabel,
        'vehicle_train_max_weight': value.vehicleTrainMaxWeight,
        'vehicle_tractor_max_weight': value.vehicleTractorMaxWeight,
        'cng': value.cng,
        'disabled_at': value.disabledAt === undefined ? undefined : (value.disabledAt === null ? null : value.disabledAt.toISOString()),
        'forwarded_to_dff': value.forwardedToDff,
        'last_sync_with_dff': value.lastSyncWithDff === undefined ? undefined : (value.lastSyncWithDff === null ? null : value.lastSyncWithDff.toISOString()),
        'dff_sync_traceback': value.dffSyncTraceback,
        'monitoring_device': value.monitoringDevice,
        'client': value.client,
        'monitored_object_type': value.monitoredObjectType,
        'driver_application': value.driverApplication,
        'external_system': value.externalSystem,
        'country_of_registration': value.countryOfRegistration,
    };
}


